import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import validation from '../../../components/Validator/validationRules';
import check from '../images/icons/check-circle-icon.svg';
import API from '../../../utils/API';
import PasswordValidationDisplay from '../settings/ValidationDisplay';
import { useSelector } from 'react-redux';
import './password-page.css';



const Password: React.FC = () => {
  const [isSavepassword, setSavepassword] = useState(false);
  const [validationSuccess, setValidationSuccess] = useState(false);
  const redux = useSelector((state: any) => state);
  const reduxUser = redux.signin;

  const [input, setInput] = useState<{
    newPassword: string;
    currentPassword: string;
    confirmNewPassword: string;
  }>({
    newPassword: '',
    currentPassword: '',
    confirmNewPassword: ''
  });

  const [passwordValidator, setPasswordValidator] = useState({
    MinCharacterLength: false,
    Empty: false,
    NotPasswordMatch: false,
    currentPasswordNotMatch: false
  });

  // show/hide toggles for the last two fields
  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  // save password and toggle success message
  const savePassword = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (validationSuccess === false) {
      console.log('invalid password');
      return;
    }

    API.checkPassword(reduxUser._id, input.currentPassword)
      .then((response) => {
        if (response.data.passwordMatch === true) {
          API.updatePassword(reduxUser._id, input.newPassword)
            .then((response) => {
              if (response.data.updated === true) {
                setSavepassword(true);
              } else {
                console.log('user not updated');
              }
            })
            .catch((error: any) => console.log(error));
        } else {
          setPasswordValidator((v) => ({ ...v, currentPasswordNotMatch: true }));
        }
      })
      .catch((error: any) => console.log(error));
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));

    if (name === 'newPassword') {
      setPasswordValidator((v) => ({
        ...v,
        Empty: !validation.NotEmpty(value),
        MinCharacterLength: !validation.minStringLength(value, 8)
      }));
    }
  };

  useEffect(() => {
    if (input.newPassword.length > 0) {
      if (input.confirmNewPassword !== input.newPassword) {
        setValidationSuccess(false);
        setPasswordValidator((v) => ({ ...v, NotPasswordMatch: true }));
      } else {
        setValidationSuccess(true);
        setPasswordValidator((v) => ({ ...v, NotPasswordMatch: false }));
      }
    }
  }, [input.confirmNewPassword, input.newPassword]);

  const cancel = () => {
    setInput({ newPassword: '', currentPassword: '', confirmNewPassword: '' });
    setPasswordValidator({
      MinCharacterLength: false,
      Empty: false,
      NotPasswordMatch: false,
      currentPasswordNotMatch: false
    });
    setValidationSuccess(false);
    setShowNew(false);
    setShowConfirm(false);
  };

  return (
    <div className="pw-shell">
      <div className="pw-wrap">
        <h1 className="pw-title">Change Password</h1>

        {isSavepassword ? (
          <div className="change-password-success-container" style={{ marginInline: '0' }}>
            <p>Your password has been reset successfully!</p>
            <img src={check} alt="check" />
          </div>
        ) : (
          <form className="pw-form" autoComplete="off">
            {/* Current Password */}
            <div className="pw-field">
              <label className="pw-label">Current Password</label>
              <div className="pw-input-wrap">
                <input
                  className="pw-input"
                  type={showOld ? 'text' : 'password'}
                  name="currentPassword"
                  required
                  value={input.currentPassword}
                  onChange={handleChange}
                />
                {showOld ? (
                  <FaEye className="pw-eye" onClick={() => setShowOld(false)} />
                ) : (
                  <FaEyeSlash className="pw-eye" onClick={() => setShowOld(true)} />
                )}
              </div>
            </div>
            <PasswordValidationDisplay
              currentPasswordNotMatch={passwordValidator.currentPasswordNotMatch}
              TextValidation_Input={{ input: 'newPassword', minLength: 8 }}
            />

            {/* New Password */}
            <div className="pw-field">
              <label className="pw-label">New Password</label>
              <div className="pw-input-wrap">
                <input
                  className="pw-input"
                  type={showNew ? 'text' : 'password'}
                  name="newPassword"
                  required
                  value={input.newPassword}
                  onChange={handleChange}
                />
                {showNew ? (
                  <FaEye className="pw-eye" onClick={() => setShowNew(false)} />
                ) : (
                  <FaEyeSlash className="pw-eye" onClick={() => setShowNew(true)} />
                )}
              </div>
            </div>
            <PasswordValidationDisplay
              MinCharacterLength={passwordValidator.MinCharacterLength}
              Empty={passwordValidator.Empty}
              TextValidation_Input={{ input: 'newPassword', minLength: 8 }}
            />

            {/* Confirm New Password */}
            <div className="pw-field">
              <label className="pw-label">Retype New Password</label>
              <div className="pw-input-wrap">
                <input
                  className="pw-input"
                  type={showConfirm ? 'text' : 'password'}
                  name="confirmNewPassword"
                  required
                  value={input.confirmNewPassword}
                  onChange={handleChange}
                />
                {showConfirm ? (
                  <FaEye className="pw-eye" onClick={() => setShowConfirm(false)} />
                ) : (
                  <FaEyeSlash className="pw-eye" onClick={() => setShowConfirm(true)} />
                )}
              </div>
            </div>
            <PasswordValidationDisplay
              NotPasswordMatch={passwordValidator.NotPasswordMatch}
              TextValidation_Input={{ input: 'confirmNewPassword' }}
            />

            {/* Buttons */}
            <div className="pw-actions">
              <button className="pw-btn" type="button" onClick={savePassword}>
                Save Changes
              </button>
              <button className="pw-btn" type="button" onClick={cancel}>
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default Password;
